export enum EstadoPruebaLaboratorio {
    PENDIENTE = 0,
    APROBADA = 1,
    RECHAZADA = 2
}